import Vue from 'vue';
import Router from 'vue-router';

import Login from '../components/Login';
import AboutPage from '../components/AboutPage';
import Dashboard from '../components/Dashboard';
import InvitePage from '../components/InvitePage';
import Project from '../components/Project/Project';
import UserProfile from '../components/UserProfile';
import ShareFilePage from '../components/ShareFilePage';
import ErrorPage from '../components/Shared/ErrorPage.vue';
import ProjectHome from '../components/Project/Home/ProjectHome';
import ProjectTasks from "../components/Project/Tasks/ProjectTasks";
import ProjectRoomCreator from "../components/Room/ProjectRoomCreator";
import ProjectFiles from '../components/Project/Files/ProjectFiles.vue';
import ProjectSettings from "../components/Project/Settings/ProjectSettings";
import toastr from "toastr";
import i18n from '@/i18n.bootstrap';
import AdminSettings from "@/components/AdminSettings/AdminSettings";


Vue.use(Router);

const router = new Router({
  routes: [
    {
        path: '',
        redirect: () => {
            return '/login';
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: (to, from, next) => {
            let loggedInUser = localStorage.getItem('login');
            return loggedInUser ? next({name: 'dashboard'}) : next();
        }
    },
    {
        path: '/about',
        name: 'about',
        component: AboutPage,
    },
    {
        path: '/user-profile',
        name: 'user-profile',
        component: UserProfile,
    },
    {
        path: "/invite/:token",
        name: "invite",
        component: InvitePage
    },
    {
        path: '/share/:shareToken',
        name: 'share-file',
        component: ShareFilePage
    },
    {
        path: '/projects',
        name: 'dashboard',
        component: Dashboard,
    },
    {
        path: '/projects/:projectId',
        component: Project,
        children: [
            {
                path: '',
                name: 'project-home',
                component: ProjectHome,
                beforeEnter: (to, from, next) => {
                    if (to.params.membership) {
                        next();
                    } else {
                        router.app.$store.dispatch('projects/loadProjectById', { projectId: to.params.projectId })
                            .then((response) => {
                                if (response.data.membership) {
                                    next();
                                } else {
                                    next({name: 'dashboard'});
                                    toastr.error(i18n.t('general.forbidden'));
                                }
                            });
                    }
                }
            },
            {
                path: 'files',
                name: 'project-files',
                component: ProjectFiles
            },
            {
                path: 'tasks',
                name: 'project-tasks',
                component: ProjectTasks,
                beforeEnter: (to, from, next) => {
                    if (to.params.showTasks) {
                        next();
                    } else {
                        router.app.$store.dispatch('projects/loadProjectById', { projectId: to.params.projectId })
                            .then((response) => {
                                if (response.data.showTasks) {
                                    next();
                                } else {
                                    next({name: 'dashboard'});
                                    toastr.error(i18n.t('general.notFound'));
                                }
                            });
                    }
                }
            },
            {
                path: 'settings',
                name: 'project-settings',
                component: ProjectSettings
            }
        ]
    },
      {
          path: '/admin-settings',
          name: 'admin-settings',
          component: AdminSettings
      },
    {
        path: '/create-project-room/:objectid/:session',
        name: 'project-room-creator',
        component: ProjectRoomCreator
    },
    {
        path: '/404',
        name: 'error-page',
        alias: '*',
        component: ErrorPage,
        props: true
    }
  ]
});

export default router;
